import React, { useRef, useEffect } from 'react';
import { createRoot, Root } from 'react-dom/client';
import shadowCss from '../assets/css/user-reviews.css?inline';
import UserReviewsModule from './user-reviews-module';

const ShadowContext = React.createContext<ShadowRoot | null>(null);

const UserReviewsShadowRoot = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const reactRootRef = useRef<Root>();

  useEffect(() => {
    const host = containerRef.current;
    if (!host) return;

    // If a shadowRoot already exists, clear *all* its contents:
    if (host.shadowRoot) {
      host.shadowRoot.innerHTML = '';
    }

    // (Re-)attach a fresh ShadowRoot only once per host:
    const shadow = host.shadowRoot ?? host.attachShadow({ mode: 'open' });
    // 1) Inject style
    const style = document.createElement('style');
    style.textContent = shadowCss;
    shadow.appendChild(style);

    // 2) Mount React
    const inner = document.createElement('div');
    shadow.appendChild(inner);
    reactRootRef.current = createRoot(inner);
    reactRootRef.current.render(
      <div className="max-w-7xl mx-auto">
        <ShadowContext.Provider value={shadow}>
          <UserReviewsModule />
        </ShadowContext.Provider>
      </div>
    );

    return () => {
      // unmount React tree
      reactRootRef.current?.unmount();
      // and clear the shadow DOM so the next mount starts fresh
      shadow.innerHTML = '';
    };
  }, []);

  return <div ref={containerRef} />;
};

export default UserReviewsShadowRoot;

export { ShadowContext };